import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../common/global-variables';
import { Modal } from '@clr/angular';

@Component({
  selector: 'data-protection-vcd',
  styles: [require('./dataprotection-vcd.scss')],
  template: require('./dataprotection-vcd.html')
})
export default class DataProtectionVCD {
  private isDeletedVappPopupVisible: boolean = false;
  private isVappPopupVisible: boolean = false;
  private isActivityLogPopupVisible: boolean = false;

  //Keep a dummy VDC, as of now, until integrating with DPS card
  private selectedVDC = {
    "id" : "8bbf32f0-6154-44e6-8fc4-819b01fcb053",
    "name" : "automation-vdc",
    "statistics" : {
      "storageConsumed" : 0.0,
      "protectedVAppCount" : 5,
      "totalVAppCount": 10
    },
    "type" : "OrgVdc",
    "properties" : {
      "operation" : "VAPP_SCHEDULE_BACKUP",
      "jobId" : "bb04f3d8-2dc3-4aa6-b214-464ade19d703",
      "state" : "TASK_IN_PROGRESS"
    }
  }

  constructor(private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
    console.log('init dataprotection component');
  }

  openDeletedVapps = ($event) => {
    this.isDeletedVappPopupVisible = true;
  };
  openVapps = ($event) => {
    this.isVappPopupVisible = true;
  };
  openActivityLog = ($event) => {
    this.isActivityLogPopupVisible = true;
  };
};



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/dataprotection-vcd.component.ts